@import 'common/component';

:host {
  display: block;
}

.breadcrumbs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0.8rem 0;
  position: relative;
  z-index: 2;
  margin: 0;
}